import { toast } from 'react-toastify';
import AsnAPI from '../../../Api/asn';

export type PrintType = 'unit' | 'carton' | 'hangtag';

export const generateTestZPL = async (userId: string, type: PrintType) => {
  try {
    const response = await AsnAPI.createTestPrintLabelRequest(userId, type);

    if (!response) {
      toast('Failed to get test print data', {
        type: 'error',
      });
      return null;
    }
    return {
      zpl: response.zpl[0],
      request_id: response.request_id,
    };
  } catch (error: unknown) {
    console.error('Failed to get test print data', error);
    toast('Failed to get test print data', {
      type: 'error',
    });
    return null;
  }
};
